import { render, staticRenderFns } from "./ComponentDrawer.vue?vue&type=template&id=27fdf3d6&scoped=true&"
import script from "./ComponentDrawer.vue?vue&type=script&lang=js&"
export * from "./ComponentDrawer.vue?vue&type=script&lang=js&"
import style0 from "./ComponentDrawer.vue?vue&type=style&index=0&id=27fdf3d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fdf3d6",
  null
  
)

export default component.exports